export default "__VITE_ASSET__DdV1zeTj__";